<div class="dropdown">
  <div #inputElement data-testid="dropdown-selector" (click)="toggleDropdown()" [ngClass]="{'selector':true, 'have-value': !!value}">
    @if (!value) {
      <div class="empty">Please select</div>
    }
    @if (value) {
      <div>{{value}}</div>
    }
    <div class="arrow">
    </div>
  </div>
  <div #optionsElement [hidden]="!showingOptions" class="options">
    @for (option of options; track option) {
      <div data-testid="dropdown-option" class="option" (click)="select(option)">{{option}}</div>
    }
  </div>
</div>
